import { produce } from 'immer';

import { LoadInternalMarketer } from '../../../actions/marketer/internal/loadInternalMarketer';
import { MarketersPageStates, MarketerState } from '../../../typings/marketers';

export function loadInternalMarketer(state: MarketerState, action: LoadInternalMarketer): MarketerState {
    return produce(state, draft => {
        draft.pageStatus = MarketersPageStates.LOADING;
    });
}
